import { TextInput } from '@/components';
import { TextField } from '@mui/material';
import { formatDate } from '@/utils';
import {
  AUTHORIZATION_STATUS_LABELS,
  AUTHORIZATION_STATUS_CHIP_CLASSES,
  DEFAULT_STATUS_CHIP_CLASS,
  AUTHORIZATION_STATUS_DOT_CLASSES,
  DEFAULT_STATUS_DOT_CLASS,
} from '../../../config';
import { AuthorizationTransition } from '../../../models';

interface AuthorizationInfoCardProps {
  authorization: AuthorizationTransition;
}

const AuthorizationInfoCard = ({ authorization }: AuthorizationInfoCardProps) => {
  const statusLabel =
    AUTHORIZATION_STATUS_LABELS[authorization.status] || authorization.status;
  const statusChipClass =
    AUTHORIZATION_STATUS_CHIP_CLASSES[authorization.status] ||
    DEFAULT_STATUS_CHIP_CLASS;
  const statusDotClass =
    AUTHORIZATION_STATUS_DOT_CLASSES[authorization.status] ||
    DEFAULT_STATUS_DOT_CLASS;

  const driverFullName = authorization.requestDriver
    ? `${authorization.requestDriver.firstName || ''} ${authorization.requestDriver.lastName || ''}`.trim()
    : 'N/A';

  return (
    <div className='bg-white rounded-xl shadow-sm p-10'>
      <div className='flex flex-wrap items-center justify-between gap-4 mb-8 border-b border-gray-100 pb-6'>
        <h2 className='text-2xl font-bold text-gray-800'>
          Detalle de Solicitud de Autorización
        </h2>
        <span
          className={`inline-flex items-center gap-1.5 px-4 py-1.5 rounded-md text-sm font-semibold ${statusChipClass}`}
        >
          <span
            className={`w-2 h-2 rounded-full flex-shrink-0 ${statusDotClass}`}
          />
          {statusLabel}
        </span>
      </div>

      <div className='grid grid-cols-1 sm:grid-cols-2 gap-8'>
        <TextInput
          name='auth-driver-name'
          placeholder='Conductor Solicitante'
          value={driverFullName}
          onChange={() => {}}
          disabled
        />
        <TextInput
          name='auth-transition-name'
          placeholder='Checkpoint'
          value={authorization.transition?.name || 'N/A'}
          onChange={() => {}}
          disabled
        />
        <TextInput
          name='auth-created-at'
          placeholder='Fecha de Solicitud'
          value={formatDate(authorization.createdAt)}
          onChange={() => {}}
          disabled
        />
        <TextInput
          name='auth-resolved-at'
          placeholder='Fecha de Resolución'
          value={
            authorization.authorized
              ? formatDate(authorization.authorized)
              : 'Pendiente de Autorizar'
          }
          onChange={() => {}}
          disabled
        />
        {(authorization.authorizationUserId ||
          authorization.status === 'ACCEPTED_NO_DISCREPANCIES') && (
          <div className='sm:col-span-2'>
            <TextInput
              name='auth-supervisor'
              placeholder='Autorizado por'
              value={
                authorization.status === 'ACCEPTED_NO_DISCREPANCIES'
                  ? 'Autorizado vía sistema'
                  : authorization.authorizationUser
                  ? `${authorization.authorizationUser.firstName || ''} ${authorization.authorizationUser.lastName || ''}`.trim()
                  : 'N/A'
              }
              onChange={() => {}}
              disabled
            />
          </div>
        )}
        {authorization.authorizationReason && (
          <div className='sm:col-span-2'>
            <TextField
              label='Motivo de autorización'
              value={authorization.authorizationReason}
              disabled
              multiline
              minRows={2}
              maxRows={6}
              fullWidth
              variant='outlined'
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthorizationInfoCard;
